import React from 'react';
import { FaLightbulb, FaMoon } from 'react-icons/fa';


const SwitcherHeader = () => {

    const switchColor = () => {
        document.querySelector('body').classList.toggle("active-dark-mode");
    }

    return (

        <button
            onClick={switchColor}
            aria-label="Toggle color mode"
        >
            <span className="setColor dark" aria-hidden="true">
                <FaLightbulb />
            </span>
            <span className="setColor light" aria-hidden="true">
                <FaMoon />
            </span>
        </button>

    )
}

export default SwitcherHeader;